// src/pages/ComplementaryUnitForm.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { createComplementaryUnit, updateComplementaryUnit } from '../services/ComplementaryUnitService';
import { getAdditionalTypesByStageId } from '../services/AdditionalTypeServices';
import { getStageById } from '../services/StageServices';
import { getUnitById, updateUnit } from '../services/UnitServices';

import './Forms.css';


function ComplementaryUnitForm() {
    const { id, stageId } = useParams();
    const [projectId, setProjectId] = useState(null);
    const [projectSlug, setProjectSulg] = useState('');
    const [unit, setUnit] = useState({
        code: '',
        status: 'available',
        additionalTypeId: '',
        stageId: stageId,
        slug: '',
        unitId: '',
        assigned: false,
        createdAt: ""
    });
    const [additionalTypes, setAdditionalTypes] = useState([]);
//    const [assignedUnitName, setAssignedUnitName] = useState('');
    const [blocksList, setBlocksList] = useState([]);
    const [selectedBlock, setSelectedBlock] = useState('');
    const [unitsList, setUnitsList] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const types = await getAdditionalTypesByStageId(stageId);
                setAdditionalTypes(types || []);

                const stageData = await getStageById(stageId);
                setProjectId(stageData.projectId);
                setProjectSulg(stageData.slug);
                setBlocksList(stageData.blocks || []);

                const allComplementaryUnits = stageData.complementaryUnits || [];

                if (id) {
                    const unitData = allComplementaryUnits.find(unit => unit.id === id);
                    if (unitData) {
                        setUnit(unitData);

                        if (unitData.unitId) {
                            const blockWithUnit = stageData.blocks?.find(b =>
                                b.units.some(u => u.id === unitData.unitId)
                            );
                            if (blockWithUnit) {
                                setSelectedBlock(blockWithUnit.id);
                                setUnitsList(blockWithUnit.units || []);
                            }
//                            const mainUnit = await getUnitById(unitData.unitId);
//                            const name = mainUnit?.unit?.name || mainUnit?.name || "Unidad sin nombre";
//                            setAssignedUnitName(name);
                        }
                    } else {
                        setError("Unidad no encontrada en la etapa");
                    }
                } else {
                    const today = new Date().toISOString().split("T")[0];
                    setUnit(prev => ({ ...prev, createdAt: today }));
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id, stageId]);

    const generateSlug = (code) => {
        const codeSlug = code.toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-');
        return `${projectSlug}-${codeSlug}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setUnit(prev => {
            const updatedUnit = { ...prev, [name]: value };

            if (name === 'code' && value) {
                updatedUnit.slug = generateSlug(value);
            }

            return updatedUnit;
        });
    };

    const handleBlockChange = (e) => {
        const blockId = e.target.value;
        setSelectedBlock(blockId);

        const block = blocksList.find(b => b.id === blockId);
        setUnitsList(block ? block.units : []);

        setUnit(prev => ({ ...prev, unitId: '' }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setError(null);
            setLoading(true);

            let savedComplementary;
            if (id) {
                savedComplementary = await updateComplementaryUnit(unit);
            } else {
                savedComplementary = await createComplementaryUnit(unit);
            }

            if (unit.unitId && savedComplementary) {
                const unitData = await getUnitById(unit.unitId);

                if (unitData) {
                    const updatedMainUnit = {
                        ...unitData.unit,
                        complementaryUnits: [
                            ...(unitData.unit.complementaryUnits || []),
                            savedComplementary.attributes ? savedComplementary.attributes : savedComplementary
                        ]
                    };
                    await updateUnit(unit.unitId, updatedMainUnit);
                }
            }

            navigate(`/stages/edit/${projectId}/${stageId}`);

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Cargando...</div>;
    }

    const isSold = unit.status === "sold";

    return (
        <div className="page-container">
            <div className="form-container">
                <h2>{id ? 'Editar Unidad Complementaria' : 'Nueva Unidad Complementaria'}</h2>
                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>

                    <div className="form-group">
                        <label htmlFor="createdAt">Fecha de creación</label>
                        <input
                            type="date"
                            id="createdAt"
                            name="createdAt"
                            value={unit.createdAt || ""}
                            disabled
                            readOnly
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="code">Código</label>
                        <input
                            type="text"
                            id="code"
                            name="code"
                            value={unit.code}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {blocksList.length > 0 && (
                        <div className="form-group">
                            <label htmlFor="block">Bloque</label>
                            <select id="block" value={selectedBlock} onChange={handleBlockChange}>
                                <option value="">Seleccione un bloque</option>
                                {blocksList.map(b => (
                                    <option key={b.id} value={b.id}>
                                        {b.name || `Bloque ${b.id}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {selectedBlock && (
                        <div className="form-group">
                            <label htmlFor="unitId">Unidad</label>
                            <select
                                id="unitId"
                                name="unitId"
                                value={unit.unitId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Seleccione una unidad</option>
                                {unitsList.map(u => (
                                    <option key={u.id} value={u.id}>
                                        {u.name || u.code || `Unidad ${u.id}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="status">Estado</label>
                        <select
                            id="status"
                            name="status"
                            value={unit.status}
                            onChange={handleChange}
                            required
                            disabled={isSold}>
                            <option value="available">Disponible</option>
                            {id && (
                                <>
                                    <option value="sold">Vendido</option>
                                </>
                            )}

                        </select>
                    </div>

                    <div className="form-group">
                        <label>Asignado</label>
                        <div style={{ display: "flex", gap: "20px" }}>
                            <div className="checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        className="checkbox-input"
                                        checked={unit.assigned === true}
                                        onChange={() => setUnit(prev => ({ ...prev, assigned: true }))}
                                    />
                                    Sí
                                </label>
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        className="checkbox-input"
                                        checked={unit.assigned === false}
                                        onChange={() => setUnit(prev => ({ ...prev, assigned: false }))}
                                    />
                                    No
                                </label>
                            </div>
                        </div>
                    </div>



                    <div className="form-group">
                        <label htmlFor="additionalTypeId">Tipo</label>
                        <select
                            id="additionalTypeId"
                            name="additionalTypeId"
                            value={unit.additionalTypeId}
                            onChange={handleChange}
                            required
                            disabled={isSold}
                        >
                            <option value="">Seleccione un tipo</option>
                            {additionalTypes.map(type => (
                                <option key={type.id} value={type.id}>
                                    {type.name} ({type.group === 'PARK' ? 'Parqueadero' : 'Cuarto útil'})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="slug">Slug (auto-generado)</label>
                        <input
                            type="text"
                            id="slug"
                            name="slug"
                            value={unit.slug}
                            readOnly
                        />
                    </div>

                    <div className="form-group">
                        <button type="submit" className="btn-submit">
                            {id ? 'Actualizar' : 'Crear'}
                        </button>
                    </div>
                </form>

                <div className="form-footer">
                    <Link  onClick={() => navigate(-1)} className="back-link">
                        Regresar
                    </Link>
                </div>

            </div>
        </div>
    );
}

export default ComplementaryUnitForm;